import { useState } from 'react';

// Hook de ordenação por coluna. Padrão canônico do portal-rh.
//   const { toggle, icon, aplicar } = useSort('nome');
//   <th onClick={()=>toggle('nome')}>Nome {icon('nome')}</th>
//   const ordenados = aplicar(linhas, (row, key) => row[key]);
export function useSort(defaultKey, defaultDir = 'asc') {
  const [sort, setSort] = useState({ key: defaultKey, dir: defaultDir });

  const toggle = (key) => {
    setSort((s) => (s.key === key ? { key, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }));
  };

  const icon = (key) => (sort.key !== key
    ? <i className="bi bi-arrow-down-up ms-1" style={{ opacity: 0.28, fontSize: '0.7rem' }} />
    : (sort.dir === 'asc'
        ? <i className="bi bi-caret-up-fill ms-1" style={{ fontSize: '0.65rem' }} />
        : <i className="bi bi-caret-down-fill ms-1" style={{ fontSize: '0.65rem' }} />));

  const aplicar = (arr, extractor) => {
    const ext = extractor || ((row, key) => row[key]);
    const decorado = arr.map((row, i) => [ext(row, sort.key), i, row]);
    decorado.sort((a, b) => {
      const va = a[0], vb = b[0];
      const aNula = va == null || va === '';
      const bNula = vb == null || vb === '';
      if (aNula && bNula) return a[1] - b[1];
      if (aNula) return 1;
      if (bNula) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return sort.dir === 'asc' ? va - vb : vb - va;
      const tryDate = (v) => {
        if (v instanceof Date) return v.getTime();
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) return new Date(v).getTime();
        return null;
      };
      const da = tryDate(va), db = tryDate(vb);
      if (da != null && db != null) return sort.dir === 'asc' ? da - db : db - da;
      const cmp = String(va).localeCompare(String(vb), 'pt-BR', { sensitivity: 'base' });
      return sort.dir === 'asc' ? cmp : -cmp;
    });
    return decorado.map((x) => x[2]);
  };

  return { sort, toggle, icon, aplicar };
}

export default useSort;
